// extracted by mini-css-extract-plugin
export default {"button":"button-svGWJGAy","disabled":"disabled-j5ezlLOm","primary":"primary-WWVowipz","dark":"dark-hImgQBoB","outline":"outline-nCiqBuzm"};